import React, { useState, useEffect, useContext, useRef } from "react"
import styled from "styled-components"
import colors from "styles/colors"
import text from "styles/text"
import media from "styles/media"
import gsap from "gsap"
import getMedia from "utils/getMedia"

const MarketoForm = props => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [stepDone, setStepDone] = useState(false)
  const formWidth = getMedia("1096px", "76.111vw", "90.82vw", "87.85vw")
  const formHeight = getMedia("733px", "50.875vw", "77.137vw", "288.084vw")
  const lineWidth = getMedia("220px", "15.278vw", "19.531vw", "7.187vw")
  const formPosition = getMedia(-28, -28, -27, 0)
  const contentVisibility = getMedia(0, 0, 0, 1)
   const languageRef = useRef("en");
   const originRef = useRef("pl")

  useEffect(() => {
    function getOriginDomain(url) {
      return url.split(".com")[0] + ".com";
    }

    if (typeof window !== "undefined") {
      const originDomain = getOriginDomain(window.location.hostname);

      if (originDomain.includes('printerlogic')) {
        originRef.current = "pl";
      } else if (originDomain.includes('vasion')) {
        originRef.current = "va";
      }
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hostname = window.location.hostname;

      if (hostname.startsWith("de")) {
        languageRef.current = "de";
      } else if (hostname.startsWith("fr")) {
        languageRef.current = "fr";
      }
    }
  }, []);

  useEffect(() => {
    if (!document.getElementById("mktoForms")) {
      loadScript()
    } else {
      setIsLoaded(true)
    }
  }, [])
  useEffect(() => {
    const demoTl = gsap.timeline({ paused: true });
    gsap.set(".bookit-content-container", { display: "none", opacity: 0 });
  
    if (props.animatedDemo) {
      demoTl
        .to(".preformContent", { opacity: contentVisibility })
        .to(".marketoForm", { opacity: 0 }, "<")
        .to("#formPos", { xPercent: formPosition, duration: 1.25 })
        .to("#formContainer", { width: formWidth, height: formHeight, duration: 1.25 }, "<")
        .to(".lines", { width: lineWidth, duration: 1.25 }, "<")
        .from(".second", { duration: 1.25, background: "unset" }, "<")
        .to(".marketoForm", { display: "none" }, "<")
        .set(".bookit-content-container", { display: "block" })
        .to(".bookit-content-container", { opacity: 1 });
    }
  
    const script = document.createElement("script");
    script.src = "https://cdn.leandata.com/js-snippet/ld-book-v2.js";
    script.async = false;
  
    script.addEventListener("load", () => {
      console.log('timeoutLang', languageRef.current)
      const urlParams = new URLSearchParams(window.location.search);
      const aliIdExists = urlParams.has("aliId");
      const initConfig = {
        calendarTimeoutLength: 900,
        beforeRouting: (formTarget, formData) => {
          console.log("lean data language:", languageRef.current); // Use the ref here
        formData["thank_you_language"] = languageRef.current;
        formData["origin_domain"] = originRef.current;
        },
        useIframe: props.animatedDemo,
      };
      
      window.LDBookItV2.initialize(
        "00DE0000000bt64MAA",
        "Demo Request - EN",
        "LD_BookIt_Log_ID__c",
        initConfig
      );
      
      if (aliIdExists) {
        window.LDBookItV2.submit(props.animatedDemo ? { cb: window.LDBookItV2.getIframeFn("100%", "100%", "300") } : undefined);
        if (props.animatedDemo) {
          demoTl.play();
          setStepDone(true);
        }
      } else {
        window.LDBookItV2.setFormProvider("marketo");
      }
    });
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  

  useEffect(() => {
    isLoaded &&
      window.MktoForms2.loadForm(
        "https://info.printerlogic.com",
        "338-HTA-134",
        props.id,
        function (form) {
          form.onSuccess(function (submittedValues) {
            if (props.animatedDemo) {
              console.log("Thank You")
            } else if (
              !props.ty &&
              !props.animatedDemo &&
              props.redirectLink !== null
            ) {
              console.log("Form submitted successfully:", submittedValues);
              document.location.href = props.redirectLink
              return false
            } else if (props.ty) {
              console.log("Form submitted successfully:", submittedValues);
              document.location.href = props.ty
              return false
            } else if (
              !props.ty &&
              !props.animatedDemo &&
              !props.redirectLink
            ) {
              console.log("Form submitted successfully:", submittedValues);
              document.location.href =
                "https://printerlogic.com/demo-request-thank-you/"
              return false
            }
          })
        }
      )
  }, [isLoaded, props.id, props.ty])

  const loadScript = () => {
    var s = document.createElement("script")
    s.id = "mktoForms"
    s.type = "text/javascript"
    s.async = true
    s.src = "https://info.printerlogic.com/js/forms2/js/forms2.min.js"
    s.onreadystatechange = function () {
      if (this.readyState === "complete" || this.readyState === "loaded") {
        setIsLoaded(true)
      }
    }
    s.onload = () => setIsLoaded(true)
    document.getElementsByTagName("head")[0].appendChild(s)
  }

  return (
    <>
      <FormContainer id="formContainer" mode={props.mode}>
        {props?.heading ? (
          <Heading mode={props.mode}>{props.heading}</Heading>
        ) : (
          props.animatedDemo && (
            <>
              <CalendarContainer className="bookit-content-container" />
              <StepsContainer>
                <Step>
                <Circle>
                  {stepDone ? "✔" : 1}
                </Circle>
                  <StepText>Fill Out Form</StepText>
                </Step>
                <Line className="lines" />
                <Line className="lines second" />
                <Step>
                <Circle className="second">
                  {" "}
                  2
                </Circle>
                  <StepText id="stepTwo">Pick Your Time</StepText>
                </Step>
              </StepsContainer>
            </>
          )
        )}
        <Form
          className="marketoForm"
          mode={props.mode}
          id={`mktoForm_${props.id}`}
        ></Form>
      </FormContainer>
    </>
  )
}

export default MarketoForm

const Step = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${colors.lightPurpleGrey};
  padding: 0.347vw 0.556vw;
  border-radius: 6.944vw;
  gap: 0.278vw;

  ${media.fullWidth} {
    padding: 5px 8px;
  border-radius: 100px;
  gap: 4px;
  }
  
  ${media.tablet} {
    padding: 0.488vw 0.781vw;
  border-radius: 9.766vw;
  gap: 0.391vw;
  }
  
  ${media.mobile} {
  
  }
`
const StepText = styled.p`
${text.bodySm};
width: max-content;
`
const Line = styled.div`
  width: 4.514vw;
  border: 0.069vw solid ${colors.lightPurpleGrey};

  ${media.fullWidth} {
    width: 65px;
    border: 1px solid ${colors.lightPurpleGrey};
  }

  ${media.tablet} {
    width: 6.348vw;
    border: 0.098vw solid ${colors.lightPurpleGrey};
  }

  ${media.mobile} {
    width: 7.187vw;
    border: 0.234vw solid ${colors.lightPurpleGrey};
  }
`
const Circle = styled.div`
  position: relative;
  ${text.bodySm};
  color: ${colors.primaryOrange};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 0.208vw solid ${colors.primaryOrange};
  width: 2vw;
  height: 2vw;

  ${media.fullWidth} {
    border: 3px solid ${colors.primaryOrange};
    width: 29px;
    height: 29px;
  }

  ${media.tablet} {
    border: 0.293vw solid ${colors.primaryOrange};
    width: 2.832vw;
    height: 2.832vw;
  }

  ${media.mobile} {
    border: 0.701vw solid ${colors.primaryOrange};
    width: 6.776vw;
    height: 6.776vw;
  }
`
const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: min-content;
  margin-bottom: 2.222vw;

  ${media.fullWidth} {
    margin-bottom: 32px;
  }

  ${media.tablet} {
    margin-bottom: 3.125vw;
  }

  ${media.mobile} {
    margin-bottom: 7.477vw;
  }
`
const CalendarContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  justify-self: center;
  align-self: center;
  overflow: hidden;
  top: 7vw;
  width: 72.639vw;
  height: 42.403vw;
  border-radius: 0.833vw;

  ${media.fullWidth} {
    top: 101px;
    width: 1046px;
    height: 611px;
    border-radius: 12px;
  }

  ${media.tablet} {
    top: 9.863vw;
    width: 87.938vw;
    height: 65.223vw;
    border-radius: 1.172vw;
  }

  ${media.mobile} {
    top: 29.598vw;
    width: 82.009vw;
    height: 255.374vw;
    border-radius: 2.804vw;
  }
`
const Heading = styled.h3`
  color: ${props =>
    props.mode === "dark" ? `${colors.white}` : `${colors.grey800}`};
  margin-bottom: 2.222vw;
  text-align: center;
  ${text.h3}

  ${media.fullWidth} {
    margin-bottom: 32px;
  }

  ${media.tablet} {
    margin-bottom: 3.125vw;
  }

  ${media.mobile} {
    margin-bottom: 7.477vw;
    ${text.h3}
  }
`
const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${props =>
    props.mode === "dark"
      ? `linear-gradient(180deg, #583F99 0%, #3D2562 100%)`
      : `${colors.white}`};
  border-radius: 1.667vw;
  padding: 2.778vw;
  width: 39.167vw;
  box-shadow: 0vw 0.069vw 0.139vw 0vw rgba(0, 0, 0, 0.3),
    0vw 0.139vw 0.417vw 0vw rgba(0, 0, 0, 0.15);

  ${media.fullWidth} {
    border-radius: 24px;
    padding: 40px;
    width: 564px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3),
      0px 2px 6px 0px rgba(0, 0, 0, 0.15);
  }
  ${media.tablet} {
    border-radius: 2.344vw;
    padding: 3.906vw;
    width: 45.313vw;
    box-shadow: 0vw 0.098vw 0.195vw 0vw rgba(0, 0, 0, 0.3),
      0vw 0.195vw 0.586vw 0vw rgba(0, 0, 0, 0.15);
  }
  ${media.mobile} {
    border-radius: 5.607vw;
    padding: 9.346vw;
    width: 87.85vw;
    box-shadow: 0vw 0.234vw 0.467vw 0vw rgba(0, 0, 0, 0.3),
      0vw 0.467vw 1.402vw 0vw rgba(0, 0, 0, 0.15);
  }

  .mktoGutter {
    height: unset !important;
  }

  option {
    ${text.bodyMd};
  }

  .mktoHtmlText {
    width: unset !important;
  }

  .mktoOffset {
    height: unset !important;
  }

  .mktoButton {
    ${text.bodyMdBold};
  }

  .mktoButtonWrap {
    margin-left: unset !important;
  }

  .mktoButtonRow {
    display: flex;
    justify-content: center;
    align-items: center;

    .mktoError {
      display: none;
    }
  }

  .mktoError {
    right: 3vw !important;
    bottom: 1.2vw !important;

    ${media.fullWidth} {
      right: 13px !important;
      bottom: 5px !important;
    }

    ${media.tablet} {
      right: 1.27vw !important;
      bottom: 0.488vw !important;
    }

    ${media.mobile} {
      right: 3.037vw !important;
      bottom: 2.168vw !important;
    }
  }

  .mktoErrorMsg {
    ${text.bodySm};
    padding: unset !important;
    background-color: unset !important;
    background-image: unset !important;
    box-shadow: unset !important;
    border: unset !important;
    text-shadow: unset !important;
    color: red !important;
  }

  .mktoErrorArrowWrap {
    display: none;
  }
  /* This is for the partner label that is shown on the conditional */
  .mktoForm label {
    color: ${props =>
      props.mode === "dark" ? `${colors.white}` : `${colors.grey800}`};
    font-family: "Archivo", sans-serif;
    ${text.bodySm};
    line-height: unset;

    ${media.mobile} {
      ${text.bodySm};
    }
  }

  & .marketoFieldWrap {
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: flex-end;
    width: 46.729vw !important;
    gap: 1.168vw;

    ${media.fullWidth} {
      width: 200px !important;
      gap: 5px;
    }

    ${media.tablet} {
      width: 19.531vw !important;
      gap: 0.488vw;
    }

    ${media.mobile} {
      width: 46.729vw !important;
      gap: 1.168vw;
    }
  }

  & .mktoForm .mktoRequiredField .mktoAsterix {
    display: none;
  }

  & #LblformFieldPartnerType {
    display: none;
  }

  & .mktoForm {
    width: 33.611vw !important;
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
    margin-left: 0 !important;

    ${media.fullWidth} {
      width: 484px !important;
    }

    ${media.tablet} {
      width: 37.5vw !important;
    }

    ${media.mobile} {
      width: 82.243vw !important;
      margin-left: -5.841vw !important;
    }
  }

  & .mktoCaptchaDisclaimer {
    display: none;
  }

  & .mktoForm input[type="text"],
  .mktoForm input[type="email"],
  .mktoForm input[type="tel"],
  .mktoForm input[type="number"],
  .mktoForm select.mktoField {
    width: 33.611vw !important;
    border: 0.134vw solid ${colors.grey400};
    border-radius: 0.255vw;
    background: rgba(255, 255, 255, 0.1) !important;
    color: ${props =>
      props.mode === "dark" ? `${colors.white}` : `${colors.grey800}`};
    height: 4vw !important;
    margin-top: 0.347vw;
    padding-left: 1.111vw;

    ${media.fullWidth} {
      width: 484px !important;
      border: 1px solid ${colors.grey400};
      border-radius: 4px;
      height: 44px !important;
      padding-left: 16px;
      margin-top: 5px;
    }

    ${media.tablet} {
      width: 37.5vw !important;
      border: 0.098vw solid ${colors.grey400};
      border-radius: 0.391vw;
      height: 4.297vw !important;
      padding-left: 1.563vw;
      margin-top: 0.488vw;
    }

    ${media.mobile} {
      width: 82.243vw !important;
      border: 0.098vw solid ${colors.grey400};
      border-radius: 0.411vw;
      height: 10.28vw !important;
      padding-left: 3.738vw;
      margin-top: 1.168vw;
    }
  }

  & .mktoForm input:focus,
  .mktoForm select:focus {
    background: ${colors.white} !important;
    color: ${colors.grey800};
  }

  & .mktoForm input:not(:focus),
  .mktoForm select:not(:focus) {
    background: ${props =>
      props.mode === "dark" ? `${colors.primaryPurple}` : `${colors.white}`};
    color: ${colors.white};
  }

  input::placeholder {
    color: ${props =>
      props.mode === "dark" ? `${colors.white}` : `${colors.grey700}`};
    ${text.bodyMd};

    ${media.mobile} {
      ${text.bodySm};
    }
  }

  .mktoForm button {
    background-color: ${colors.primaryOrange} !important;
    color: ${colors.white} !important;
    border-radius: 1.528vw;
    padding: 0.694vw 2.083vw;
    font-size: 1.111vw !important;
    margin-top: 1.667vw !important;

    ${media.fullWidth} {
      border-radius: 22px;
      padding: 10px 30px;
      font-size: 16px !important;
      margin-top: 24px !important;
    }
    ${media.tablet} {
      border-radius: 2.148vw;
      padding: 0.977vw 2.93vw;
      font-size: 1.563vw !important;
      margin-top: 2.344vw !important;
    }
    ${media.mobile} {
      border-radius: 5.14vw;
      padding: 2.336vw 4.673vw;
      font-size: 3.738vw !important;
      margin-top: 5.607vw !important;
    }
  }

  & .mktoForm .mktoFormRow .mktoField {
    ${text.bodyMd};
    color: ${colors.grey700};

    ${media.mobile} {
      ${text.bodySm};
    }
  }

  & .mktoForm .mktoFormRow .mktoField:not(:focus) {
    ${text.bodyMd};
    color: ${colors.grey200};

    ${media.mobile} {
      ${text.bodySm};
    }
  }

  & .mktoHtmlText {
    ${text.bodySm};
    margin-top: 1.667vw !important;

    ${media.fullWidth} {
      margin-top: 24px !important;
    }
    ${media.tablet} {
      margin-top: 2.344vw !important;
    }
    ${media.mobile} {
      margin-top: 3.738vw !important;
    }
  }

  & .mktoForm .mktoCheckboxList {
    padding: 2.336vw 0vw 0vw 0vw;

    ${media.fullWidth} {
      padding: 10px 0px 0px 0px;
    }
    ${media.tablet} {
      padding: 0.977vw 0vw 0vw 0vw;
    }
    ${media.mobile} {
      padding: 1.869vw 0vw 0vw 0vw;
    }
  }

  span {
    text-decoration: none !important;
  }

  & .mktoHtmlText span {
    font-family: Archivo;
    font-style: normal;
    font-weight: 400;
    font-size: 1.111vw !important;
    line-height: 1.667vw !important;
    color: ${props =>
      props.mode === "dark" ? `${colors.white}` : `${colors.grey800}`};

    ${media.fullWidth} {
      font-size: 16px !important;
      line-height: 24px !important;
    }
    ${media.tablet} {
      font-size: 1.563vw !important;
      line-height: 2.344vw !important;
    }
    ${media.mobile} {
      font-size: 3.738vw !important;
      line-height: 5.607vw !important;
    }
  }

  & .mktoForm a {
    color: ${colors.primaryOrange} !important;
    text-decoration: none !important;
    font-family: "Archivo", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1.111vw !important;
    line-height: 1.667vw !important;

    ${media.fullWidth} {
      font-size: 16px !important;
      line-height: 24px !important;
    }
    ${media.tablet} {
      font-size: 1.563vw !important;
      line-height: 2.344vw !important;
    }
    ${media.mobile} {
      font-size: 3.738vw !important;
      line-height: 5.607vw !important;
    }
  }
`
const Form = styled.form``
